import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import { ProductArea } from '@newmoon-org/types';
import { NotificationProgrammatic, DialogProgrammatic } from 'buefy';

import { getForCatalog, create, update, remove } from '@/service/productAreas.service';

import list, { ListConfig } from '@/components/list/list.vue';
import AddProductAreaModal from '@/components/productAreas/AddProductAreaModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductAreas',
  props: {
    catalogId: null
  },
  setup(__props: any) {

const props = __props as {
  catalogId: string;
}



const productAreas = ref<ProductArea[]>([]);
const selectedProductArea = ref<ProductArea | undefined>(undefined);
const showModal = ref<boolean>(false);
const listConfig = ref<ListConfig<ProductArea>>({
  title: 'Product Areas',
  emptyText: 'No product areas in catalog',
  labelField: 'label',
  isSearchable: true,
  titleActions: [
    {
      label: 'Add Product Area',
      icon: 'plus',
      action: () => {
        selectedProductArea.value = undefined;
        showModal.value = true;
      },
      style: 'is-primary',
    },
  ],
  listActions: [
    {
      label: 'Edit',
      icon: 'edit',
      action: (args: { row: ProductArea }) => {
        selectedProductArea.value = args.row;
        showModal.value = true;
      },
    },
    {
      label: 'Delete',
      icon: 'trash',
      action: async (args: { row: ProductArea }) => {
        await removeProductArea(args.row);
      },
      style: 'is-danger',
    },
  ],
});

onMounted(async () => {
  await loadProductAreas();
});

async function loadProductAreas() {
  try {
    productAreas.value = await getForCatalog(props.catalogId);
  } catch (e) {
    console.error(e);
    NotificationProgrammatic.open({
      message: 'Error loading product areas',
      type: 'is-danger',
    });
    productAreas.value = [];
  }
}

function onCloseModal() {
  showModal.value = false;
  selectedProductArea.value = undefined;
}

async function removeProductArea(productArea: ProductArea) {
  try {
    DialogProgrammatic.confirm({
      title: 'Delete Product Area',
      message: `Are you sure you want to delete ${productArea.label}?`,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        await remove(productArea);
        await loadProductAreas();
      },
    });
  } catch (e) {
    console.error(e);
    NotificationProgrammatic.open({
      message: 'Error deleting product area',
      type: 'is-danger',
    });
  }
}
async function submit(productArea: ProductArea) {
  try {
    const toUpsert = {
      ...productArea,
      catalogType: {
        id: props.catalogId,
      },
    };
    if (productArea.id) {
      await update(toUpsert);
    } else {
      await create(toUpsert);
    }
    await loadProductAreas();
  } catch (e) {
    console.error(e);
    NotificationProgrammatic.open({
      message: 'Error saving product area',
      type: 'is-danger',
    });
  } finally {
    showModal.value = false;
    selectedProductArea.value = undefined;
  }
}

return { __sfc: true,props, productAreas, selectedProductArea, showModal, listConfig, loadProductAreas, onCloseModal, removeProductArea, submit, list, AddProductAreaModal }
}

})